<!--
 * @Author:
 * @Description: 新增缺陷
-->
<template>
  <CockpitDialog
    :title="remarkData.Id ? '编辑备注' : '新增备注'"
    class="left-550px top-240px text-white !text-opacity-80 w-[40%] h-1/2"
    @close="close"
  >
    <div class="w-full h-full relative">
      <el-form :model="formData" ref="formRef" label-width="80px" class="mt-20px">
        <el-form-item
          label="标记描述"
          prop="BiaojiMS"
          :rules="[{ required: true, message: '必填属性' }]"
        >
          <el-input
            v-model="formData.BiaojiMS"
            :autosize="{ maxRows: 6, minRows: 6 }"
            size="small"
            resize="none"
            placeholder=""
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="text-center absolute bottom-10px w-full">
        <el-button class="mr-10px" @click="submit"> 保存</el-button>
        <el-button @click="close">取消</el-button>
      </div>
    </div>
  </CockpitDialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import DiyCodeService from '../../../../service/DiyCodeService'

export default {
  name: 'RemarkDialog',
  components: {
    CockpitDialog,
  },
  props: {
    remarkData: {
      type: Object,
      defalut: () => {},
    },
    FlagId: {
      type: String,
      defalut: '',
    },
  },
  data() {
    return {
      formData: {
        BiaojiMS: null,
      },
    }
  },
  computed: {},
  created() {
    if (this.remarkData.Id) {
      this.formData = _.cloneDeep(this.remarkData)
    }
  },
  methods: {
    close() {
      this.$emit('close', false)
    },
    async submit() {
      await this.$refs.formRef.validate()
      try {
        if (this.remarkData.Id) {
          const param = {
            FormEngineKey: 'diy_3DCoordinationManagement_Descripts',
            Id: this.remarkData.Id,
            _RowModel: _.pick(this.formData, ['BiaojiMS']),
          }
          // eslint-disable-next-line no-return-await
          await DiyCodeService.uptFormData(param)
        } else {
          const params = {
            FormEngineKey: 'diy_3DCoordinationManagement_Descripts',
            _FormData: {
              ...this.formData,
              FlagId: this.FlagId,
            },
          }
          // eslint-disable-next-line no-return-await
          await DiyCodeService.addFormData(params)
        }
        this.$message.success('保存成功！')
      } finally {
        this.close()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep.el-button--default {
  color: #fff !important;
}
</style>
